import React from 'react';
import { useCallOnceWhen } from '../../hooks/useCallOnceWhen';
import classes from './UsageLimitCard.module.scss';

const UsageLimitCard = ({
  message,
  handleBrowseLotteries,
  handleQuickPick,
  onWidgetDataLoaded,
}) => {
  useCallOnceWhen(true, onWidgetDataLoaded);

  return (
    <div className={classes.Container}>
      <h3 className={classes.Title}>{message}</h3>
      <div className={classes.Buttons}>
        <button
          type="button"
          onClick={() => handleBrowseLotteries()}
          className={classes.Button + ' ' + classes.Browse}
        >
          Browse lotteries
        </button>
        <button
          type="button"
          onClick={() => handleQuickPick()}
          className={classes.Button + ' ' + classes.QuickPick}
        >
          Try quick pick
        </button>
      </div>
    </div>
  );
};

export default UsageLimitCard;
